import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

// Size picker for sized merchandise (T-Shirts, Hoodies). The full size range is
// always listed so counter staff can see what exists at a glance, but a size with
// no stock behind it is greyed out and non-interactive so it can never be sold.
export default function WalkInSizePicker({ open, tile, onSelect, onClose }) {
  return (
    <AnimatePresence>
      {open && tile && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
        >
          <motion.div
            initial={{ scale: 0.96, y: 16 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.96, y: 16 }}
            transition={{ type: 'spring', stiffness: 240, damping: 22 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg bg-[#111115] border border-white/10 overflow-hidden"
          >
            <div className="flex items-center justify-between gap-3 px-6 py-4 border-b border-white/10">
              <div className="min-w-0">
                <p className="text-primary text-[10px] font-bold tracking-widest">SELECT A SIZE</p>
                <h3 className="text-white font-black text-lg uppercase leading-tight truncate">{tile.name}</h3>
              </div>
              <button
                onClick={onClose}
                className="w-9 h-9 shrink-0 flex items-center justify-center bg-white/5 hover:bg-white/10 text-white/60 hover:text-white transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-5">
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
                {tile.options.map((opt) => (
                  <button
                    key={opt.id}
                    type="button"
                    disabled={!opt.available}
                    onClick={() => onSelect(opt.id)}
                    className={`relative border-2 px-3 py-4 text-center transition-colors ${
                      opt.available
                        ? 'border-white/10 bg-[#0d0d0f] hover:border-primary hover:bg-primary/10'
                        : 'border-white/5 bg-[#0d0d0f] opacity-40 pointer-events-none'
                    }`}
                  >
                    <span className="block text-white font-black text-base leading-tight">{opt.label}</span>
                    <span className={`block font-black text-sm mt-1 ${opt.available ? 'text-primary' : 'text-white/40'}`}>
                      £{opt.price.toFixed(2)}
                    </span>
                    {!opt.available && (
                      <span className="absolute top-1.5 right-1.5 bg-red-500/20 text-red-300 text-[9px] font-bold tracking-wider px-1.5 py-0.5">
                        OUT OF STOCK
                      </span>
                    )}
                  </button>
                ))}
              </div>
              <p className="text-white/25 text-[11px] text-center mt-4">
                Sizes with no stock are shown but can't be sold.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}